import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class OfferProductsSelectionService {
  constructor(private http: HttpClient) {}

  applyOfferProducts(eventId: number, eventProductItemIds: number[]): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/api/events/${eventId}/offer-products`,
      { event_product_item_ids: eventProductItemIds }
    );
  }
}
